import {GetHeaderResponse_Redirect} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.types';
import {useHistory, useQueryParamsCallback} from '@aboutyou/router';
import {useShowToast} from '@aboutyou/ui-components';
import {useEffect} from 'react';

/**
 * Redirects the user to the link backend provided and shows a toast
 * @param props
 */
export const useCLPRedirect = (redirect?: GetHeaderResponse_Redirect) => {
  const history = useHistory();
  const showToast = useShowToast();
  const queryParams = useQueryParamsCallback();

  useEffect(() => {
    // Only redirect when `redirect` is present and `loginReason` is absent.
    // When `loginReason` exists (e.g., user arrives from a newsletter),
    // skip the redirect as the coupon may be invalid for guests but valid
    // after authentication. The backend correctly returns redirect for the
    // current guest state, but we expect the user to authenticate first.
    if (redirect && !queryParams().get('loginReason')) {
      history.replace(redirect.redirectUrl.url);
      showToast({
        content: redirect.toastMessage,
        type: 'INFO',
      });
    }
  }, []);
};
